module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-FR.2eb82ed.webp";